import React, { Component } from "react";
import ComponentOperation from "./PartMasterStandards";
import axios from "../../httpServices/httpService";
import endPoint from "../../config";
import swal from "sweetalert";
import joi from "joi";
import valid from "../../utill/validation";
import Loading from "../../utill/LoadingComponent";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleDown, faArrowCircleUp, faPencilAlt, faTrash } from "@fortawesome/free-solid-svg-icons";
import MultiSelect from "../../Common/multiselect";
import { ToastContainer, toast } from 'react-toastify';
import config from '../../config.json'


class PartMasterTest extends Component {
  state = {
    componentData: { Standards: [] },
    noOfOperations: [],
    NumberOfOperations: 0,
    oldObj: {},
    toolRequireRadioState: "Description",
    cycleTimeRadioState: 1,
    selectedEquipmentRequired: "",
    inspectionTypeList: [],
    toolList: [],
    errors: {},
    querySuccess: false,
    modelState: false,
    Standard: {},
    index: 0,
    opStatus: "",
    operationList: [],
    selectedEquiType: '',
    count: 0,

    customerList: [],

    toolList: [],
    querySuccess: false,
    actionStatus: false,
    opStatus: false,

  };
  schemaFull = {

    PartID: joi.string().required().label("Part Id"),
    PartName: joi.string().required().label("Part Name"),
    _id:joi.string(),
    

    Standards: joi
      .array()
      .items(
        joi.object().keys({
          _id:joi.string(),
          InspectionType: joi.string().required(),
          StandardVersion: joi.string().required(),
          EffectiveFrom: joi.date().required(),
          UpdatedAt:joi.date(),
          Standard: joi.array().min(1),
        })
      )
      .unique('InspectionType')
      .min(1)
      .required()
      .label("Duplicate Inspection Add"),
  };

  comparator = (a, b) => {
    return a.OperationID === b.OperationID;
  }

  componentDidMount() {
    this.props.Heading('Part Master')

    const { location } = this.props.history;
    this.setState({ querySuccess: true });

    axios
      .get(config.api + "inspectionType")
      .then((result) => {
        // consol(result.data);
        this.setState({ inspectionTypeList: result.data, querySuccess: false });
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });
      });
    this.setState({ querySuccess: true });

    // axios
    //   .get(api.api + "operation")
    //   .then((result) => {
    //     this.setState({ operationList: result.data, querySuccess: false });
    //   })
    //   .catch((err) => {
    //     this.setState({ querySuccess: false });
    //     toast.success(`${err}`, {
    //       position: 'bottom-right',
    //       autoClose: 2000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       style: {
    //         background: 'red', // Set your desired background color
    //         color: 'white',     // Set your desired text color
    //       },
    //     });
    //   });
    if (location.state && location.state.action === "add") {
      this.setState({ componentData: { Standards: [] } });
    }
    if (location.state && location.state.action === "update") {
      const component = { ...location.state.data };

      this.setState({
        componentData: { ...location.state.data },
        oldObj: component,
      });
    }
  }
  handleOnChangeOperation = (e, name1) => {
    const { Standard, errors } = { ...this.state };
    if (name1 == 'Tool') {
      // const errorMessage = valid.validateProperty({value:e.value,name:name1}, schema);
      // if (errorMessage) newErrors[name1] = errorMessage;
      // else delete newErrors[name1];
    }
    else {
      // const errorMessage = valid.validateProperty(e.currentTarget, this.schema);
      // if (errorMessage) errors[e.currentTarget.name] = errorMessage;
      // else delete errors[e.currentTarget.name];

    }

    if (name1 == 'Tool') {
      let tool = []
      if (e) {
        this.state.toolList.forEach(one => {
          e.forEach(t => {
            if (one.ToolId == t.value) {
              tool.push(t.value)
            }
          })
        })
      }
      this.setState({ ChnageEvent: name1 })
      Standard[name1] = tool;
    }
    else {
      Standard[e.currentTarget.name] = e.currentTarget.value;
      this.setState({ ChnageEvent: e.currentTarget.name })
    }
    this.setState({ Standard: Standard, errors: errors || {} })

    // this.props.handleClickOk(Operation);

  };

  handleRadioChange = (e) => {
    //const { component } = { ...this.state };
    const { Standard } = { ...this.state };
    const { name, value } = e.currentTarget;

    if (name === `StandardType|${this.props.id}`) {
      Standard[e.currentTarget.name.split('|')[0]] = e.currentTarget.value;
      if (value === 'Description') {
        this.setState({ Operation: Standard });
      }
      else {
        this.setState({ Operation: Standard });
      }
    }
  };

  handleSubmitModelClick = (operation) => {
    const { location } = this.props.history;
    delete operation.StandardSerial;
    delete operation.StandardType;
    delete operation._id;


    const errors1 = valid.validate(operation, this.schema);
    this.setState({ errors: errors1 || {} })
    if (errors1) { return }
    this.handleSubmitModel(operation);
  }


  schema = {

    InspectionType: joi.string().required(),
    // OperationSerial: joi.number().min(0).required(),
    StandardVersion: joi.string().required(),
    // NetWeightPerComponent: joi.number().min(1).required(),
    EffectiveFrom: joi.date(),
    UpdatedAt:joi.date(),
    Standard: joi
    .array().min(1)
    
    // PartsPerCycle: joi
    //   .number().min(0).label('PartsPerCycle').when("ToolRequiredToProduce", { is: false, then: joi.required() }),

    // // ScrapWeightCycle: joi
    // //   .number()
    // //   .min(1)
    // //   .when("ToolRequiredToProduce", { is: false, then: joi.required() }),

    // IdealCycleTime: joi
    //   .number()
    //   .min(0)
    //   .when("ToolRequiredToProduce", { is: false, then: joi.required() }),
  }

  getToolListForValue = (Operation) => {
    let arr = []
    if (Operation.Tool !== undefined) {

      if (Operation.Tool.length > 0) {
        Operation.Tool.forEach(one => {
          let obj = {}
          obj.label = one
          obj.value = one
          arr.push(obj)
        })
        return arr
      }
      else {
        return arr
      }
    }
    else {
      return arr
    }
  }
  getToolListForOptions = (list) => {
    let arr = []
    list.forEach(one => {
      let obj = {}
      obj.label = one.ToolId
      obj.value = one.ToolId
      arr.push(obj)
    })
    return arr
  }





  handleOnChange = (e) => {
    const { componentData, noOfOperations, errors } = { ...this.state };
    const { name, value } = e.currentTarget;
    if (name !== 'Alias') {
      const errorMessage = valid.validateProperty(e.currentTarget, this.schemaFull);
      if (errorMessage) errors[e.currentTarget.name] = errorMessage;
      else delete errors[e.currentTarget.name];
    }


    componentData[e.currentTarget.name] = e.currentTarget.value;
    this.setState({ componentData, noOfOperations, errors: errors || {} });
  };

  handleChangeEquipmentType = (e) => {
    const { Operation } = { ...this.state };
    Operation[e.currentTarget.name] = e.currentTarget.value
    let type = e.currentTarget.value;
    type = this.state.equipmentTypeList.filter(one => one.EquipmentType == type)[0];
    axios
      .put(endPoint.api + "tool", { EquipmentType: type._id })
      .then((result) => {
        this.setState({ toolList: result.data, Operation: Operation, querySuccess: false });
      })
      .catch((err) => {
        this.setState({ querySuccess: false });
        toast.success(`${err}`, {
          position: 'bottom-right',
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            background: 'red', // Set your desired background color
            color: 'white',     // Set your desired text color
          },
        });
      });

  }


  // schema1 = {
  //   Tool: joi
  //     .array().unique().min(1)
  //     .when("ToolRequiredToProduce", { is: true, then: joi.required() }),
  //   OperationID: joi.string().required(),
  //   OperationSerial: joi.number().min(0).required(),
  //   EquipmentType: joi.string().required(),
  //  // NetWeightPerComponent: joi.number().min(1).required(),
  //   ToolRequiredToProduce: joi.bool().required(),
  //   PartsPerCycle: joi
  //     .number()
  //     .min(1).required(),
  //     // .when("CycleTime", { is: "PPC", then: joi.required() }),
  //   // CyclePerParts: joi
  //   //   .number()
  //   //   .min(0)
  //   //   .when("CycleTime", { is: "CPP", then: joi.required() }),

  //   // ScrapWeightCycle: joi
  //   //   .number()
  //   //   .min(1)
  //   //   .when("ToolRequiredToProduce", { is: false, then: joi.required() }),
  //   IdealCycleTime: joi
  //     .number()
  //     .min(1)
  //     .when("ToolRequiredToProduce", { is: false, then: joi.required() }),
  // };

  handleSubmitModel = (operation) => {
    const { location } = this.props.history;
    const { componentData, opStatus } = { ...this.state };
    if (location.state && location.state.action == "add") {
      if (opStatus === "add") {
        componentData.Standards.push(operation);
        this.setState({
          componentData,
          modelState: false,
          Standard: {},
        });
        // consol(componentData);
      }
      if (opStatus === "update") {
        // componentData.Standards.forEach((one,index)=>{
        //   if(one.InspectionType==operation.InspectionType){
        //     componentData.Standard[index]=operation
        //   }
        // })
        componentData.Standards.filter(obj => obj.InspectionType == operation.InspectionType)[0] = operation
        this.setState({
          count: 0,
          componentData,
          modelState: false,
          Standard: {},
        });
      }

    }
    if (location.state && location.state.action == "update") {
      delete operation.CycleTime;
      if (opStatus === "add") {
        componentData.Standards.push(operation);
      } if (opStatus === "update") {
        // operation["OperationSerial"] = this.state.Operation.OperationSerial;
        // this.state.componentData.Operation[this.state.index] = operation;
        let index = 0;
        componentData.Standards.forEach((obj, i) => {
          if (obj.StandardSerial == operation.StandardSerial) {
            index = i
          }
        })
        componentData.Standards[index] = operation
        this.setState({
          componentData,
          modelState: false,
          Standard: {},
        });
      }
      // consol(componentData);

      this.setState({

        componentData,
        modelState: false,
        Standard: {},
      });
    }
  };
  handleSubmit = (data) => {
    const { location } = this.props.history
    const { componentData } = this.state;
    if (location.state && location.state.action === "add") {
      // componentData.Standards.map((one, i) => {
      //   one["StandardSerial"] = i + 1;
      // });
      const errors = valid.validate(data, this.schemaFull);
      this.setState({ errors: errors || {} });
      if (errors) return;

      this.setState({ querySuccess: true });

      axios
        .post(config.api + "partMaster", data)
        .then((result) => {
          if (result.status == 200) {
            this.setState({ querySuccess: false });
            swal("Save Data Successfully");
            this.props.history.push("/setting/partMaster/list");
          } else {
            this.setState({ querySuccess: false });
            swal(`Data Not Saved`);
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          swal(`${err.response.data.message}`);
        });
    }
    if (location.state && location.state.action === "update") {
      // componentData.Operation.map((one, i) => {
      //   one["StandardSerial"] = i + 1;
      // });
      // componentData["NumberOfOperations"] = componentData.Operation.length;
      const errors = valid.validate(data, this.schemaFull);
      this.setState({ errors: errors || {} });
      if (errors) return;
      this.setState({ querySuccess: true });
      axios
        .patch(config.api + "partMaster/" + data._id, {
          old: this.state.oldObj,
          new: data
        })
        .then((result) => {
          const { n, nModified, ok } = result.data;
          if (ok == 1 && n == 1 && nModified == 1) {
            this.setState({ querySuccess: false });
            this.props.history.push("/setting/partMaster/list");
            swal("Updated Data Successfully");
          } else {
            this.setState({ querySuccess: false });
            swal(`${result.data}`);
          }
        })
        .catch((err) => {
          this.setState({ querySuccess: false });
          swal(`${err.response.data.message}`);
        });
    }
  };
  handleAddOperation = () => {
    // const {count}=this.state;
    // count++
    this.setState({ modelState: true, opStatus: "add", Standard: {} });
  };
  handleHideModel = () => {
    this.setState({ modelState: false, Standard: {} });
  };
  handleEditOperation = (operation, index) => {
    // consol(operation);
    // consol(index);

    this.setState({ Standard: operation, modelState: true, index: index, opStatus: "update" });
  };
  handleRemoveOperation = (operation, i) => {
    const componentData = { ...this.state.componentData };
    let operations = componentData.Standards.filter(obj => obj.InspectionType !== operation.InspectionType)
    componentData.Standards = operations;
    //componentData.Operation.splice(i, 1);ss
    this.setState({ componentData });
  };

  handleUpShiftOperation = (operation, currentIndex) => {
    const componentData = { ...this.state.componentData };
    let repObj = componentData.Standards[currentIndex - 1];
    componentData.Standards[currentIndex] = repObj;
    if (0 <= currentIndex - 1) {
      componentData.Standards[currentIndex - 1] = operation;
      this.setState({ componentData });
    } else {
      swal('No More Operation For Shifting to Up')
    }

  }

  handleDownShiftOperation = (operation, currentIndex) => {
    const componentData = { ...this.state.componentData };
    let repObj = componentData.Standards[currentIndex + 1];
    componentData.Standards[currentIndex] = repObj;
    if (componentData.Standards.length - 1 >= currentIndex + 1) {
      componentData.Standards[currentIndex + 1] = operation;
      this.setState({ componentData });
    } else {
      swal('No More Operation For Shifting to Down')
    }

  }


  render() {
    return (
      <div className="" id="parent">              <ToastContainer />

        {this.state.querySuccess ? <Loading /> : ""}
        <div className="row text-center">
          <div className="col-sm-4 ">
            <div className="form-group ">
              <label>Part ID</label>
              <input
                type="text"
                name="PartID"
                defaultValue={this.state.componentData.PartID}
                placeholder="Enter Part Id.."
                onChange={this.handleOnChange}
                className="form-control  form-control-sm"
              />
              {this.state.errors.PartID && (
                <div className="alert small alert-danger">
                  {this.state.errors["PartID"]}
                </div>
              )}
            </div>

          </div>
          <div className="col-sm-4 ">
            <div className="form-group ">
              <label>Part Name</label>
              <input
                type="text"
                name="PartName"
                defaultValue={this.state.componentData.PartName}
                placeholder="Enter Part Name.."
                onChange={this.handleOnChange}
                className="form-control  form-control-sm"
              />
              {this.state.errors.PartName && (
                <div className="alert small alert-danger">
                  {this.state.errors["PartName"]}
                </div>
              )}
            </div>

          </div>



        </div>
        <div>
          <a className="btn btn-primary" onClick={this.handleAddOperation}>
            Add Inspection +
          </a>
        </div>

        <ComponentOperation
          opStatus={this.state.opStatus}
          modelState={this.state.modelState}
          handleHideModel={this.handleHideModel}
          Operation={this.state.Standard}
          handleOnChange={this.handleOnChangeOperation}
          operationList={this.state.operationList}
          toolList={this.state.toolList}
          typeList={this.state.inspectionTypeList}
          errors={this.state.errors}
          handleChangeEquipmentType={this.handleChangeEquipmentType}
          standardType={this.state.toolRequireRadioState}
          handleRadioChange={this.handleRadioChange}
          getToolListForOptions={this.getToolListForOptions}
          getToolListForValue={this.getToolListForValue}
          handleCloseModel={this.handleHideModel}
          handleSubmitModelClick={this.handleSubmitModelClick}
        />
        <table className="table table-sm text-center">
          <tbody>
            {this.state.componentData.Standards.map((one, i) => {
              return (
                <tr key={i}>
                  <td className="bg-success">{`#${i + 1} Inspection  ${one.InspectionType}`}</td>
                  <td>
                    <a
                      onClick={() => this.handleEditOperation(one, i)}
                      className="btn"
                    >
                      <FontAwesomeIcon icon={faPencilAlt} color={'blue'} />
                    </a>
                  </td>
                  <td>
                    <a
                      onClick={() => this.handleRemoveOperation(one, i)}
                      className="btn "
                    >
                      <FontAwesomeIcon icon={faTrash} color={'red'} />
                    </a>
                  </td>
                  {/* <td>
                    <a
                      onClick={() => this.handleUpShiftOperation(one, i)}
                      className="btn "
                    >
                      <FontAwesomeIcon icon={faArrowCircleUp} />
                    </a>
                    <a
                      onClick={() => this.handleDownShiftOperation(one, i)}
                      className="btn "
                    >
                      <FontAwesomeIcon icon={faArrowCircleDown} />
                    </a>
                  </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>

        {/* {this.state.noOfOperations.map((one,i)=>{
          
         return <React.Fragment key={i}><tr  className='text-center collapsed bg-success ' aria-expanded="false"  aria-controls={`Operation${one}`} data-toggle='collapse'  data-target={`#Operation${one}`} style={{cursor:'pointer'}}><td>Operatoion  #{one}</td></tr>
           <ComponentOperation id={one} toolRequireRadioState={this.state.toolRequireRadioState}
           cycleTimeRadioState={this.state.cycleTimeRadioState}
           toolList={this.state.toolList}
           equipmentTypeList={this.state.equipmentTypeList}
           handleClickOk={this.handleClickOk}
           Operation={this.state.componentData.Operation}
           actionStatus={this.props.actionStatus}
           />
         </React.Fragment>
        
        })} */}

        {this.state.errors.Standards && (
          <div className="alert small alert-danger">
            {this.state.errors["Standards"]}
          </div>
        )}
        <div className="text-center">
          <button
            className="btn btn-primary"
            onClick={() => this.handleSubmit(this.state.componentData)}
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export default PartMasterTest;
